import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  companies: [],

  selectedCompany: null,

  company: null,

  momentDateFormat: null,
  color: '',

  carbonDateFormat: null,

  item_discount: false,

  defaultFiscalYear: null,

  defaultTimeZone: null,

  defaultCurrency: null,
  pack: null,
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations,
}
